export default __webpack_public_path__ + "static/media/Bracers of Righteous Smiting.88ad0959.jpg";